const OAuthSilentSignin = () =>
  import(/* webpackChunkName: "OAuth" */ '@/components/auth/OAuthSilentSignin');

const rootRoutes = [
  {
    path: '/oauth/silentsignin',
    name: 'OAuthSilentSignin',
    component: OAuthSilentSignin,
    meta: { publicRoute: true },
  },
];

export default {
  root: rootRoutes,
  core: [],
  admin: [],
};
